module.exports = __webpack_public_path__ + "img/pet-friendly.46b861a3.svg";